define('extends/Mazarine.View', [

], function() {

    return Backbone.View.extend({

        attributes: function(){
            return { "data-view-id": this.model && this.model.get('viewId') ? this.model.get('viewId') : null };
        },


        loadImages: function(preloadImages) {
            var nbImagesPreloaded = 0;

            _.each(preloadImages, _.bind(function(src) {
                var img = new Image();
                img.onerror = _.bind(function(e) {
                    console.warn("[Mazarine.View -> loadImages] Image error onload", img);
                    nbImagesPreloaded++;

                    if( e )
                        e.currentTarget.onerror = null; // Remove listener to save memory

                    var target = e ? e.currentTarget : null;

                    this.progress(target, nbImagesPreloaded, preloadImages.length, (nbImagesPreloaded === preloadImages.length) );
                }, this);
                img.onload = _.bind(function(e) {
                    nbImagesPreloaded++;

                    if( e )
                        e.currentTarget.onload = null; // Remove listener to save memory

                    var target = e ? e.currentTarget : null;

                    this.progress(target, nbImagesPreloaded, preloadImages.length, (nbImagesPreloaded === preloadImages.length) );
                }, this);
                setTimeout(function() {
                    img.src = src;
                }, 40);
            }, this));
        },

        progress: function(img, nbImagesPreloaded, nbImagesToPreload, finished) {
            //console.log("[Mazarine.View -> progress]", img, nbImagesToPreload, nbImagesPreloaded, finished);
        },

        getRenderDatas: function() {
            return this.model.toJSON();
        },

        render: function() {
            this.$el.html(this.template(this.getRenderDatas()));
            return this;
        },

        getViewId: function(){
            return (this.model && this.model.get('viewId') ? this.model.get('viewId') : null);
        },

        onEnter: function() {
            //console.log([Mazarine.View -> onEnter], this.getViewId());
        },

        onLeave: function() {
            //console.log([Mazarine.View -> onLeave], this.getViewId());
        },

        destroy: function() {
            this.undelegateEvents();
            this.remove();
            Backbone.View.prototype.remove.call(this);
        }
    });
});
